import * as Mutations from '../mutation-types'
import { set, set_one, set_many, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '../mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Mutations.SET_COUNTS]: set({ to: 'counts' }),
    [Mutations.SET_ONE]: set_one({ to: 'entities' }),
    [Mutations.SET_MANY]: set_many({ to: 'entities' }),

}
